"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_router_1 = __importDefault(require("vue-router"));
var TheHome_vue_1 = __importDefault(require("./components/TheHome.vue"));
var TheLogin_vue_1 = __importDefault(require("./components/TheLogin.vue"));
var store_1 = __importStar(require("./store"));
var views_1 = __importDefault(require("./config/views"));
var roles_json_1 = __importDefault(require("../roles.json"));
var TheStatus_vue_1 = __importDefault(require("./components/TheStatus.vue"));
vue_1.default.use(vue_router_1.default);
exports.default = new vue_router_1.default({
    mode: "history",
    routes: [
        { path: views_1.default.Home.path, name: views_1.default.Home.name, component: TheHome_vue_1.default },
        { path: views_1.default.Status.path, name: views_1.default.Status.name, component: TheStatus_vue_1.default },
        { path: views_1.default.Login.path, name: views_1.default.Login.name, component: TheLogin_vue_1.default, beforeEnter: redirectIfAuthorized },
        authorizedViewRoute(views_1.default.Roles),
        authorizedViewRoute(views_1.default.Users),
        authorizedViewRoute(views_1.default.Districts),
        authorizedViewRoute(views_1.default.Units),
        authorizedViewRoute(views_1.default.Scouts),
        authorizedViewRoute(views_1.default.Settings),
        { path: views_1.default.Logout.path, name: views_1.default.Logout.name, beforeEnter: logout }
    ]
});
function authorizedViewRoute(view) {
    return {
        path: view.path,
        name: view.name,
        component: view.component,
        beforeEnter: redirectIfUnauthorized(view),
        props: true
    };
}
function isUserPermitted(permissions) {
    if (!permissions || store_1.default.state.roles.includes(roles_json_1.default.superAdministrator)) {
        return true;
    }
    return permissions.every(function (permission) { return store_1.default.state.permissions.includes(permission); });
}
function redirectIfUnauthorized(view) {
    return function (to, from, next) {
        var authorized = store_1.default.state.authorized;
        if (!authorized || !isUserPermitted(view.permissions)) {
            return next({ path: views_1.default.Login.path });
        }
        next();
    };
}
function redirectIfAuthorized(to, from, next) {
    var authorized = store_1.default.state.authorized;
    if (authorized) {
        return next({ path: views_1.default.Home.path });
    }
    next();
}
function logout(to, from, next) {
    store_1.default.dispatch(store_1.Action.logout).then(function () {
        next({ path: views_1.default.Home.path });
    });
}
